import { __assign, __extends } from "tslib";
import { equal } from '@wry/equality';
import { DocumentType } from "../parser/index.js";
import { ApolloError } from "../../errors/index.js";
import { OperationData } from "./OperationData.js";
import { mergeOptions } from "../../core/index.js";
var MutationData = function (_super) {
  __extends(MutationData, _super);
  function MutationData(_a) {
    var options = _a.options,
      context = _a.context,
      result = _a.result,
      setResult = _a.setResult;
    var _this = _super.call(this, options, context) || this;
    _this.runMutation = function (mutationFunctionOptions) {
      if (mutationFunctionOptions === void 0) {
        mutationFunctionOptions = {};
      }
      _this.onMutationStart();
      var mutationId = _this.generateNewMutationId();
      return _this.mutate(mutationFunctionOptions).then(function (response) {
        _this.onMutationCompleted(response, mutationId);
        return response;
      }).catch(function (error) {
        var onError = _this.getOptions().onError;
        _this.onMutationError(error, mutationId);
        if (onError) {
          onError(error);
          return {
            data: undefined,
            errors: error
          };
        } else {
          throw error;
        }
      });
    };
    _this.verifyDocumentType(options.mutation, DocumentType.Mutation);
    _this.result = result;
    _this.setResult = setResult;
    _this.mostRecentMutationId = 0;
    return _this;
  }
  MutationData.prototype.execute = function (result) {
    this.isMounted = true;
    this.verifyDocumentType(this.getOptions().mutation, DocumentType.Mutation);
    return [this.runMutation, __assign(__assign({}, result), {
      client: this.refreshClient().client
    })];
  };
  MutationData.prototype.afterExecute = function () {
    this.isMounted = true;
    return this.unmount.bind(this);
  };
  MutationData.prototype.cleanup = function () {};
  MutationData.prototype.mutate = function (options) {
    return this.refreshClient().client.mutate(mergeOptions(this.getOptions(), options));
  };
  MutationData.prototype.onMutationStart = function () {
    if (!this.result.loading && !this.getOptions().ignoreResults) {
      this.updateResult({
        loading: true,
        error: undefined,
        data: undefined,
        called: true
      });
    }
  };
  MutationData.prototype.onMutationCompleted = function (response, mutationId) {
    var _a = this.getOptions(),
      onCompleted = _a.onCompleted,
      ignoreResults = _a.ignoreResults;
    var data = response.data,
      errors = response.errors;
    var error = errors && errors.length > 0 ? new ApolloError({
      graphQLErrors: errors
    }) : undefined;
    var callOncomplete = function () {
      return onCompleted ? onCompleted(data) : null;
    };
    if (this.isMostRecentMutation(mutationId) && !ignoreResults) {
      this.updateResult({
        called: true,
        loading: false,
        data: data,
        error: error
      });
    }
    callOncomplete();
  };
  MutationData.prototype.onMutationError = function (error, mutationId) {
    if (this.isMostRecentMutation(mutationId)) {
      this.updateResult({
        loading: false,
        error: error,
        data: undefined,
        called: true
      });
    }
  };
  MutationData.prototype.generateNewMutationId = function () {
    return ++this.mostRecentMutationId;
  };
  MutationData.prototype.isMostRecentMutation = function (mutationId) {
    return this.mostRecentMutationId === mutationId;
  };
  MutationData.prototype.updateResult = function (result) {
    if (this.isMounted && (!this.previousResult || !equal(this.previousResult, result))) {
      this.setResult(result);
      this.previousResult = result;
      return result;
    }
  };
  return MutationData;
}(OperationData);
export { MutationData };